import { FlagProgressType } from "./types";
// eslint-disable-next-line id-length -- matches useTranslation().t; literal t("chat:…") keys for grep / i18n extractors
export default function getReportHeaders(t) {
    return {
        [FlagProgressType.SELECT_OPTION]: {
            description: t("chat:modal.reportMessage.selectOption.description"),
            subDescription: t("chat:modal.reportMessage.selectOption.subDescription"),
        },
        [FlagProgressType.ADD_COMMENT]: {
            description: t("chat:modal.reportMessage.addComment.description"),
            subDescription: t("chat:modal.reportMessage.addComment.subDescription"),
        },
        [FlagProgressType.DONE]: {
            description: t("chat:modal.reportMessage.confirmation.description"),
            subDescription: "",
        },
        [FlagProgressType.ERROR]: {
            description: t("error:title.somethingWentWrong"),
            subDescription: t("error:subtitle.pleaseTryAgain"),
        },
    };
}
